export const tumbi = {
    rolling_type: [
        {
            actual: true,
            name: "tumba__tp_3__100x100",
            pageName: "tp_3",
            tempName: "tp_3",
            glbPath: "tumbi/",
            glbName: "tumba__tp_3.glb",
            nextMenu: "tp_3",
            menuTitle: "Тумба на 3 ящика",
            title: "Тумба на 3 ящика",
            imgName: "tp_3.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
        {
            actual: true,
            name: "tumba__tp_4__100x100",
            pageName: "tp_4",
            tempName: "tp_4",
            glbPath: "tumbi/",
            glbName: "tumba__tp_4.glb",
            nextMenu: "tp_4",
            menuTitle: "Тумба на 4 ящика",
            title: "Тумба на 4 ящика",
            imgName: "tp_4.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
    ],
    stationary_type: [
        {
            actual: true,
            name: "tumba__ts_1__100x100",
            pageName: "ts_1",
            tempName: "ts_1",
            glbPath: "tumbi/",
            glbName: "tumba__ts_1.glb",
            nextMenu: "ts_1",
            menuTitle: "Тумба с 2 полками",
            title: "Тумба с 2 полками",
            imgName: "ts_1.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
        {
            actual: true,
            name: "tumba__ts_2__100x100",
            pageName: "ts_2",
            tempName: "ts_2",
            glbPath: "tumbi/",
            glbName: "tumba__ts_2.glb",
            nextMenu: "ts_2",
            menuTitle: "Тумба с 1 ящиком и 1 полкой",
            title: "Тумба с 1 ящиком и<br /> 1 полкой",
            imgName: "ts_2.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
        {
            actual: true,
            name: "tumba__ts_3__100x100",
            pageName: "ts_3",
            tempName: "ts_3",
            glbPath: "tumbi/",
            glbName: "tumba__ts_3.glb",
            nextMenu: "ts_3",
            menuTitle: "Тумба с 3 ящиками",
            title: "Тумба с 3 ящиками",
            imgName: "ts_3.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
        {
            actual: true,
            name: "tumba__ts_5__100x100",
            pageName: "ts_5",
            tempName: "ts_5",
            glbPath: "tumbi/",
            glbName: "tumba__ts_5.glb",
            nextMenu: "ts_5",
            menuTitle: "Тумба с 5 ящиками",
            title: "Тумба с 5 ящиками",
            imgName: "ts_5.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
        {
            actual: true,
            name: "tumba__ts_7__100x100",
            pageName: "ts_7",
            tempName: "ts_7",
            glbPath: "tumbi/",
            glbName: "tumba__ts_7.glb",
            nextMenu: "ts_7",
            menuTitle: "Тумба с 7 ящиками",
            title: "Тумба с 7 ящиками",
            imgName: "ts_7.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
        {
            actual: true,
            name: "tumba__ts_10__100x100",
            pageName: "ts_10",
            tempName: "ts_10",
            glbPath: "tumbi/",
            glbName: "tumba__ts_10.glb",
            nextMenu: "ts_10",
            menuTitle: "Тумба с 10 ящиками",
            title: "Тумба с 10 ящиками",
            imgName: "ts_10.webp",
            allArrTable: "allTumbi",
            defaultWidth: 100,
            defaultDepth: 100,
        },
    ],
    hanging_type: [],
};
